<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-checkbox
          v-model="v.hasPrivilege.$model"
          label="Наличие льготы"
          hide-details
        />
      </v-col>
      <v-col v-if="v.hasPrivilege.$model" cols="12">
        <v-textarea
          v-model="v.note.$model"
          :errorMessages="getValidationErrorText(v.note)"
          outlined
          label="Примечание (основание для льготы, при наличии)"
        />
        <span class="text-small-size">
          {{ Text.hasPrivilegeNote }}
        </span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { maxLength, requiredIf } from 'vuelidate/lib/validators';
import { EMOJI } from '@/utils/validate';
import { getValidationErrorText } from '@/utils/validate';
import { Text } from '@/utils/services';

export const privilegeModel = {
  hasPrivilege: false,
  note: '',
};

export const privilegeValidation = {
  hasPrivilege: {},
  note: {
    required: requiredIf((vm) => vm.hasPrivilege),
    maxLength: maxLength(4000),
    EMOJI,
  },
};

export default {
  name: 'Privilege',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    getValidationErrorText,
    Text,
  }),
};
</script>
